export const attachmentUploadSlashItem = {
  title: 'Attachment',
  description: 'Upload a file attachment',
  icon: '📎',
  group: 'Media',
  keywords: ['attachment', 'file', 'upload', 'pdf', 'document'],
  command: ({ editor, range }) => {
    editor.chain().focus().deleteRange(range).run();
    const controllerEl = editor.view.dom.closest('[data-controller~="tiptap"]');
    window.Stimulus.getControllerForElementAndIdentifier(controllerEl, 'tiptap').initiateUpload('attachment');
  },
};
